import * as dayjs from "dayjs";

// Bank processing lag commonly shifts the recorded date by a day or two, so an exact-date
// match would miss real duplicates - allow a few days of tolerance.
export const DUPLICATE_PAYMENT_TOLERANCE_DAYS = 3;

export const isPossibleDuplicatePayment = (amountA, dateA, amountB, dateB) => {
  if (!amountA || !amountB || dateA == null || dateB == null) return false;
  const amountsMatch = Math.round(amountA * 100) === Math.round(amountB * 100);
  if (!amountsMatch) return false;
  const daysApart = Math.abs(dayjs.unix(dateA).diff(dayjs.unix(dateB), "day"));
  return daysApart <= DUPLICATE_PAYMENT_TOLERANCE_DAYS;
};

// Finds other payments (any invoice of the same supplier, including this one) that possibly
// duplicate the given payment. `payments` should already be scoped to the supplier's invoices.
export const findDuplicatePaymentMatches = (payment, payments, invoicesById) => {
  return payments
    .filter((p) => p.id !== payment.id)
    .filter((p) => isPossibleDuplicatePayment(payment.amount, payment.paymentDate, p.amount, p.paymentDate))
    .map((p) => ({ payment: p, invoice: invoicesById.get(p.invoiceId) }))
    .filter((match) => match.invoice);
};
